function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_13672_1599)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.0455 10.08H19.4501M16.0455 13.4554H19.4501M2.32779 3.88452H21.6718C21.6718 3.88452 23.1426 3.88452 23.1426 5.35538V18.6445C23.1426 18.6445 23.1426 20.1154 21.6718 20.1154H2.32779C2.32779 20.1154 0.856934 20.1154 0.856934 18.6445V5.35538C0.856934 5.35538 0.856934 3.88452 2.32779 3.88452Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.01172 10.6422C6.01172 11.3883 6.3081 12.1039 6.83567 12.6314C7.36324 13.159 8.07877 13.4554 8.82486 13.4554C9.57095 13.4554 10.2865 13.159 10.8141 12.6314C11.3416 12.1039 11.638 11.3883 11.638 10.6422C11.638 9.89615 11.3416 9.18062 10.8141 8.65305C10.2865 8.12549 9.57095 7.8291 8.82486 7.8291C8.07877 7.8291 7.36324 8.12549 6.83567 8.65305C6.3081 9.18062 6.01172 9.89615 6.01172 10.6422Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.54932 16.2393C4.97335 15.4149 5.60125 14.7126 6.37332 14.1993C7.1009 13.7186 7.9527 13.4601 8.82474 13.4553C9.68532 13.4553 10.5287 13.7125 11.2779 14.1993C12.0499 14.7126 12.6779 15.4149 13.1019 16.2393",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_13672_1599"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));
const SvgEnrollment = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnrollment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/enrollment.dd41c8ba.svg";
export { ForwardRef as ReactComponent };